import React from 'react';
import { Sun, Cloud, CloudRain, CloudSnow } from 'lucide-react';

const WeatherWidget = ({ weather, weatherTestMode, locationName = 'Eugene, OR' }) => {
  // Helper function to get weather icon and description from WMO weather code
  const getWeatherIcon = (code) => {
    if (code === 0) return { icon: Sun, desc: 'Clear' };
    if (code <= 3) return { icon: Cloud, desc: 'Partly Cloudy' };
    if (code >= 61 && code <= 67) return { icon: CloudRain, desc: 'Rainy' };
    if (code >= 71 && code <= 77) return { icon: CloudSnow, desc: 'Snowy' };
    if (code >= 80 && code <= 82) return { icon: CloudRain, desc: 'Rain Showers' };
    if (code >= 95) return { icon: CloudRain, desc: 'Thunderstorm' };
    return { icon: Cloud, desc: 'Cloudy' };
  };

  // Use test mode weather if active, otherwise use real weather
  const displayWeather = weatherTestMode ? {
    temperature: weather?.temperature || 65,
    cloudCover: weatherTestMode === 'clear' ? 0 : 100,
    weatherCode: weatherTestMode === 'clear' ? 0 :
                 weatherTestMode === 'cloudy' ? 3 :
                 weatherTestMode === 'rain' ? 65 :
                 weatherTestMode === 'snow' ? 75 :
                 weatherTestMode === 'thunderstorm' ? 95 :
                 weatherTestMode === 'all' ? 99 : 0
  } : weather;

  if (!displayWeather) return null;

  return (
    <div className="absolute right-0 top-0 flex items-center gap-3 bg-white/90 px-4 py-2 rounded-lg shadow-md">
      <span className="text-sm font-medium text-gray-700">{locationName}</span>
      <div className="h-4 w-px bg-gray-300"></div>
      {React.createElement(getWeatherIcon(displayWeather.weatherCode).icon, { className: "w-5 h-5 text-blue-600" })}
      <span className="text-lg font-semibold">{displayWeather.temperature}°F</span>
      <span className="text-sm text-gray-600">{getWeatherIcon(displayWeather.weatherCode).desc}</span>
      <span className="text-sm text-gray-500">☁️ {displayWeather.cloudCover}%</span>
      {weatherTestMode && (
        <span className="text-xs font-bold text-purple-600 ml-2 bg-purple-100 px-2 py-1 rounded">
          TEST: {weatherTestMode.toUpperCase()}
        </span>
      )}
    </div>
  );
};

export default WeatherWidget;
